export const AGREEMENT_KEYS = {
  RODO: 'rodo',
  EMAIL: 'email',
  TEL: 'tel',
  PARTNERS: 'partners',
} as const
